import { Link } from 'react-router-dom';

const guideCards = [
  {
    title: 'Best Mulebuy Spreadsheet List 2026',
    subtitle: 'Updated verified spreadsheet collections',
    path: '/article/mulebuy-spreadsheet-list-2026',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20product%20catalog%20pages%20spread%20across%20light%20desk%20with%20various%20clothing%20items%20visible%2C%20organized%20grid%20layout%20aesthetic%2C%20soft%20natural%20lighting%2C%20warm%20cream%20and%20beige%20tones%2C%20professional%20editorial%20product%20photography%2C%20shallow%20depth%20of%20field%20on%20catalog%20pages&width=600&height=800&seq=guide-list-v2&orientation=portrait',
  },
  {
    title: 'Mulebuy Agent Comparison Guide',
    subtitle: 'Compare agents side by side like a pro',
    path: '/article/mulebuy-agent-comparison',
    image: 'https://readdy.ai/api/search-image?query=Split%20comparison%20layout%20with%20two%20product%20sample%20cards%20and%20rating%20stars%20on%20clean%20desk%20surface%2C%20magnifying%20glass%20and%20checklist%20nearby%2C%20neutral%20professional%20aesthetic%2C%20soft%20studio%20lighting%2C%20cool%20gray%20and%20warm%20beige%20balanced%20tones%2C%20analytical%20decision-making%20atmosphere&width=600&height=800&seq=guide-vs-v2&orientation=portrait',
  },
  {
    title: 'Beginner Guide to Spreadsheet',
    subtitle: 'Start your sourcing journey right',
    path: '/article/mulebuy-spreadsheet-beginner',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20beginner%20desk%20setup%20with%20open%20notebook%20and%20colorful%20sticky%20notes%2C%20simple%20fashion%20accessories%20nearby%2C%20welcoming%20warm%20golden%20hour%20light%2C%20approachable%20learning%20atmosphere%2C%20terracotta%20and%20soft%20cream%20tones%2C%20encouraging%20first-steps%20aesthetic&width=600&height=800&seq=guide-beginner-v2&orientation=portrait',
  },
  {
    title: 'Safety Guide for Users',
    subtitle: 'Stay secure while sourcing products',
    path: '/article/mulebuy-spreadsheet-safety',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20small%20padlock%20symbol%20and%20verification%20checklist%2C%20reassuring%20professional%20atmosphere%2C%20soft%20mint%20and%20ivory%20tones%2C%20trustworthy%20security%20aesthetic%2C%20diffused%20natural%20lighting%2C%20calm%20protective%20composition&width=600&height=800&seq=guide-safety-v2&orientation=portrait',
  },
];

export default function GuideCardsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              Mulebuy Spreadsheet Guides
            </h2>
            <p className="mt-2 text-sm text-foreground-600">Read our expert tips and tutorials</p>
          </div>
          <Link
            to="/article/mulebuy-spreadsheet-guide"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap inline-flex items-center gap-1"
          >
            View All Guides <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {guideCards.map((guide, idx) => (
            <Link
              key={idx}
              to={guide.path}
              className="group block cursor-pointer"
            >
              <div className="relative rounded-xl overflow-hidden aspect-[3/4]">
                <img
                  src={guide.image}
                  alt={guide.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full bg-white/90 text-foreground-900 text-xs font-medium backdrop-blur-sm">
                    Guide
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-base md:text-lg font-heading font-bold text-white leading-snug">
                    {guide.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-white/80">
                    {guide.subtitle}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}